import { createFileRoute } from '@tanstack/react-router'
import OrderBreakDownScreen from './-components/screen'
import { pharmacyClient } from '@/connect'

import {z} from 'zod'
import { Loading } from '@/layouts/loading'
const Params = z.object({
  supplierId: z.string().default("all"),
  stockPointId: z.string().default("all"),
})
type Params = z.infer<typeof Params>

export const Route = createFileRoute('/(pharma)/_layout/inventory/purchase-request/$id/')({
  component: OrderBreakDownScreen,
  validateSearch: Params,
    loaderDeps: ({ search: { supplierId, stockPointId } }) => ({
      supplierId,
      stockPointId,
    }),
    loader: async ({params, deps}) => {
      const purchaseRequest = await pharmacyClient.getPurchaseRequest({
        purchaseRequestId: params.id,
      })
      const activity = await pharmacyClient.purchaseActivity({
        purchaseRequestId: params.id,
      })
      return {
        purchaseRequest: purchaseRequest,
        activity: activity,
      }
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
})